import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import ShareRequestAccessFields from 'components/common/ShareRequestAccessFields';
import {
  SHARE_ACCESS_FORM_DEFAULTS,
  validateShareRequestAccess
} from 'util/shareRequestAccess';

const ShareRequestApproveModal = ({
  show,
  onHide,
  onApprove,
  actioning,
  accessTypeId
}) => {
  const formMethods = useForm({ defaultValues: SHARE_ACCESS_FORM_DEFAULTS });
  const {
    control,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: { errors }
  } = formMethods;

  useEffect(() => {
    if (show) {
      reset(SHARE_ACCESS_FORM_DEFAULTS);
      clearErrors();
    }
  }, [show, reset, clearErrors]);

  const onFormSubmit = handleSubmit(data => {
    const accessValidation = validateShareRequestAccess(
      data.accessType,
      data.scopeFromDate,
      data.scopeToDate
    );
    if (!accessValidation.valid) {
      setError('scopeFromDate', {
        type: 'manual',
        message: accessValidation.message
      });
      return;
    }
    onApprove(data);
  });

  return (
    <Modal show={show} onHide={() => !actioning && onHide()} centered>
      <Modal.Header closeButton>
        <Modal.Title>Approve Request</Modal.Title>
      </Modal.Header>
      <FormProvider {...formMethods}>
        <Form onSubmit={onFormSubmit} noValidate>
          <Modal.Body>
            <p className="mb-3">
              Are you sure you want to approve this request?
            </p>
            <ShareRequestAccessFields
              control={control}
              errors={errors}
              disabled={actioning}
              accessTypeId={accessTypeId}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              type="button"
              onClick={onHide}
              disabled={actioning}
            >
              Cancel
            </Button>
            <Button variant="success" type="submit" disabled={actioning}>
              {actioning ? (
                <Spinner animation="border" size="sm" className="me-1" />
              ) : null}
              Approve
            </Button>
          </Modal.Footer>
        </Form>
      </FormProvider>
    </Modal>
  );
};

ShareRequestApproveModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
  actioning: PropTypes.bool,
  accessTypeId: PropTypes.string
};

ShareRequestApproveModal.defaultProps = {
  actioning: false,
  accessTypeId: 'share-request-approve-access'
};

export default ShareRequestApproveModal;
